class CoastTraceLookup extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('[data-trace-form]');
    this.input = this.querySelector('[data-trace-input]');
    this.notFound = this.querySelector('[data-trace-notfound]');
    this.qrToggle = this.querySelector('[data-trace-qr-toggle]');
    this.qrTip = this.querySelector('[data-trace-qr-tip]');

    const indexScript = this.querySelector('[data-trace-index]');
    this.index = [];
    if (indexScript) {
      try {
        this.index = JSON.parse(indexScript.textContent);
      } catch (error) {
        this.index = [];
      }
    }

    if (this.form) {
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.lookup();
      });
    }

    if (this.qrToggle && this.qrTip) {
      this.qrToggle.addEventListener('click', () => {
        this.qrTip.hidden = !this.qrTip.hidden;
      });
    }

    const paramBatch = new URLSearchParams(window.location.search).get('batch');
    if (paramBatch && this.input) {
      this.input.value = paramBatch;
      this.lookup();
    }
  }

  lookup() {
    const query = (this.input.value || '').trim().toLowerCase();
    if (!query) return;

    const match = this.index.find((item) => {
      return item.batch && item.batch.toLowerCase() === query;
    });

    if (match && match.url) {
      if (this.notFound) this.notFound.hidden = true;
      window.location.href = match.url;
    } else if (this.notFound) {
      this.notFound.hidden = false;
    }
  }
}

customElements.define('coast-trace-lookup', CoastTraceLookup);
